<template>
  <div class="new-content news-list2 boxshadow1" style="padding: 20px 30px;">
    <div
      data-v-2395165a=""
      style="height: 68px;line-height: 68px;font-weight: bold;font-size: 24px;color: #333;"
    >
      公众留言板
    </div>
    <Tabs :value="name" :animated="false" @on-click="tabclick">
      <TabPane label="留言查询" name="name1">
        <div class="input" style="display: flex;">
          <Icon
            type="search"
            style="width: 50px;
          position: absolute;
          top: 0px;
          left: 0px;
          height: 100%;
          line-height: 44px;
          cursor: pointer;
          color: rgb(153, 153, 153);
          font-size: 30px;
          text-align: center;"
          />

          <input
            v-model="title"
            style="    outline: none;
          border: none;
          padding: 0 10px 0 50px;
          margin: 0;
          line-height: 44px;
          flex: 1;
          color: #333;
          font-size: 16px;
          
         "
            type="text"
            placeholder="输入关键字查看留言问题"
            autocomplete="off"
          />

          <div
            class="search"
            @click="requesttab1(1)"
            style="width: 150px;
          height: 48px;
          background-color: rgb(172, 0, 0);
          border: 1px solid rgb(172, 0, 0);
          display: inline-block;
          background-position: center center;
          background-repeat: no-repeat;
      
          cursor: pointer;
          color: #fff;
          font-size: 16px;
          text-align: center;
          line-height: 46px;
          margin-top: -2px;"
          >
            搜索
          </div>
        </div>
        <ul class="list" v-if="!_.isEmpty(dataSet.result)">
          <li
            v-for="(item, index) in dataSet.result"
            :key="`news-list-${index}`"
            @click="$router.push({ path: 'onlineMessage/detail/' + item.no })"
          >
            <!-- <router-link :to="{name: 'NewsShow', params: {id: item.id}}" class="cover"><img :src="item.coverImage" v-if="item.coverImage"></router-link> -->
            <div class="content">
              <p class="title">
                <!-- <span class="hot" v-if="item.tags && item.tags.length > 0">{{item.tags[0].name}}</span> -->
                <span style="width: 1000px;
                padding-right: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;"
                  :class="[
                    'title',
                    'ellipsis',
                    { hotes: item.tags && item.tags.length > 0 }
                  ]"
                  >{{ item.title }}</span
                >
                <span style="margin-left:5px">[{{ item.msgTime }}]</span>
              </p>
            </div>
          </li>
        </ul>
        <div class="nodata" v-else-if="_.isEmpty(dataSet.result)">
          {{ $t("common.noResult") }}
        </div>
        <Page
          :total="dataSet.count"
          show-total
          show-elevator
          :page-size="pageSize"
          :current.sync="currentPage"
          size="small"
          @on-change="goPager"
        ></Page>
      </TabPane>
      <TabPane label="我的留言" name="name2">
        <div class="input" style="display: flex;">
          <Icon
            type="search"
            style="width: 50px;
          position: absolute;
          top: 0px;
          left: 0px;
          height: 100%;
          line-height: 44px;
          cursor: pointer;
          color: rgb(153, 153, 153);
          font-size: 30px;
          text-align: center;"
          />

          <input
            v-model="title"
            style="    outline: none;
          border: none;
          padding: 0 10px 0 50px;
          margin: 0;
          line-height: 44px;
          flex: 1;
          color: #333;
          font-size: 16px;
          
         "
            type="text"
            placeholder="输入关键字查看留言问题"
            autocomplete="off"
          />

          <div
            class="search"
            @click="requesttab2(1)"
            style="width: 150px;
          height: 48px;
          background-color: rgb(172, 0, 0);
          border: 1px solid rgb(172, 0, 0);
          display: inline-block;
          background-position: center center;
          background-repeat: no-repeat;
      
          cursor: pointer;
          color: #fff;
          font-size: 16px;
          text-align: center;
          line-height: 46px;
          margin-top: -2px;"
          >
            搜索
          </div>
        </div>

        <ul class="list" v-if="!_.isEmpty(dataSet.result)">
          <li
            v-for="(item, index) in dataSet.result"
            :key="`news-list-${index}`"
            @click="$router.push({ path: 'onlineMessage/detail/' + item.no })"
          >
            <!-- <router-link :to="{name: 'NewsShow', params: {id: item.id}}" class="cover"><img :src="item.coverImage" v-if="item.coverImage"></router-link> -->
            <div class="content">
              <p class="title">
                <!-- <span class="hot" v-if="item.tags && item.tags.length > 0">{{item.tags[0].name}}</span> -->
                <span style="width: 1000px;
                padding-right: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;"
                  :class="[
                    'title',
                    'ellipsis',
                    { hotes: item.tags && item.tags.length > 0 }
                  ]"
                  >{{ item.title }}</span
                >
                <span style="margin-left:5px">[{{ item.msgTime }}]</span>
              </p>
            </div>
          </li>
        </ul>
        <div class="nodata" v-else-if="_.isEmpty(dataSet.result)">
          {{ $t("common.noResult") }}
        </div>
        <Page
          :total="dataSet.count"
          show-total
          show-elevator
          :page-size="pageSize"
          :current.sync="currentPage"
          size="small"
          @on-change="goPager"
        ></Page>
      </TabPane>
      <TabPane label="我要留言" name="name3">
        <div v-if="step == 1">
          <div
            style="height: 68px;
          line-height: 68px;
          font-weight: bold;
          font-size: 24px;
          color: #0068b7;"
          >
            留言须知
          </div>
          <div class="pclass">
            一、不得发表违反中华人民共和国宪法和法律得留言；
          </div>
          <div class="pclass">
            二、不得发表危害领土主权、国家安全、网站安全等的留言；
          </div>
          <div class="pclass">三、不得发表造谣、诽谤他人的言论；</div>
          <div class="pclass">四、不得发表未经证实的消息，亲身经历请注明；</div>
          <div class="pclass">五、不得发表涉及个人隐私和商业秘密的留言；</div>
          <div class="pclass">六、不得发表任何形式的商业广告；</div>
          <div class="pclass">七、请勿发表与商务厅工作无关的留言；</div>
          <div class="pclass">
            八、留言人应提供真实联系方式以便核对，联系方式不实者，留言将予以删除；
          </div>
          <div class="pclass">
            九、本栏目非论坛性质，只用于商务厅机关和公众之间交流，不用于公众之间交流；
          </div>
          <div class="pclass">
            十、陕西·RCEP企业服务中心工作人员使用部内渠道反映意见和建议，不使用公众留言系统；
          </div>
          <div class="pclass">
            十一、本栏目拥有发布、编辑、删除公众留言的权利，凡不符合本须知规定的留言将予以删除；
          </div>
          <div class="pclass">
            十二、公众提交的留言须经审核后方可发布，敬请留意；
          </div>
          <div class="pclass">
            十三、留言人承担一切因留言行为引起的直接或间接法律责任；
          </div>
          <div class="pclass">
            十四、如在本栏留言，即表明已阅读并接受了上述各项条款。
          </div>
          <div
            style="font-size: 16px;
          padding: 10px 10px;
          background: #ab0000;
          color: #fff;
          width: 310px;
          text-align: center;
          margin-left: 210px;
          margin-top: 50px;cursor: pointer;"
            @click="step = 2"
          >
            我已阅读并同意以上条款，确认留言
          </div>
        </div>
        <div v-if="step == 2">
          <Form
            ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="130"
          >
            <Row>
              <Col
                span="24"
                style="  border-right: none;border-bottom: none;background: #f1f1f1;text-align:center;line-height:40px;color:#949494"
              >
                请填写您得留言信息
              </Col>
              <Col span="24" style="  border-bottom: none">
                <FormItem label="留言标题" prop="title">
                  <Input v-model="formValidate.title"></Input>
                </FormItem>
              </Col>
              <Col span="24" style="  border-bottom: none">
                <FormItem label="联系人" prop="contacts">
                  <Input v-model="formValidate.contacts"></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24" style="  border-bottom: none">
                <FormItem label="联系方式" prop="way">
                  <Input v-model="formValidate.way"></Input>
                </FormItem>
              </Col>
              <Col span="24" style="  border-bottom: none">
                <FormItem label="公开意愿">
                  <RadioGroup v-model="formValidate.publicStatus">
                    <Radio label="1">
                      公开
                    </Radio>
                    <Radio label="0">
                      不公开
                    </Radio>
                  </RadioGroup>
                  <span style="font-size: 16px;
                  vertical-align: -3px;
                  color: red;
              }">注:选择公开的将可能当作案例在网站公开</span>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24" style=" border-bottom: none;">
                <FormItem label="联系人公司" prop="company">
                  <Input v-model="formValidate.company"></Input>
                </FormItem>
              </Col>
              <Col span="24" style="  border-bottom: none">
                <FormItem label="分类">
                  <RadioGroup v-model="formValidate.type">
                    <Radio label="1">
                      咨询
                    </Radio>
                    <Radio label="2">
                      建议
                    </Radio>
                    <Radio label="3">
                      投诉
                    </Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="24" >
                <FormItem label="留言内容" prop="msg">
                  <Input
                    type="textarea"
                    :rows="4"
                    v-model="formValidate.msg"
                  ></Input>
                </FormItem>
              </Col>
            </Row>

            <div
              class="btn-wrap clearfix"
              style="text-align: center;
        margin-top: 20px;"
            >
              <Button
                type="primary"
                class="btn search"
                @click.prevent="handleSubmit"
                style="    background-color: rgb(136, 146, 243);
          border-color: rgb(136, 146, 243);width: 130px;margin:0 auto;
      
          height:30px;"
              >
                <span>提交</span>
              </Button>
            </div>
          </Form>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import LineClamp from "@/components/common/LineClamp";
import Loader from "../layout/Loader";

export default {
  name: "NewsListContent",
  components: { LineClamp, Loader },
  props: {
    pageSize: {
      type: Number
    },
    isShowLoader: {
      type: Boolean
    }
  },
  data() {
    return {
      dataSet: [],
      title: "",
      name: "name1",
      currentPage: 1,
      step: 1,
      formValidate: {
        publicStatus: "1",
        type: "1"
      },

      ruleValidate: {
        title: [
          { required: true, message: "请填写留言标题", trigger: "change" }
        ],
        contacts: [
          { required: true, message: "请填写联系人", trigger: "change" }
        ],
        way: [{ required: true, message: "请填写联系方式", trigger: "change" }],
        publicStatus: [
          { required: true, message: "请选择公开意愿", trigger: "change" }
        ],

        company: [
          { required: true, message: "请填写联系人公司", trigger: "change" }
        ],
        msg: [{ required: true, message: "请填写留言内容", trigger: "change" }]
      }
    };
  },
  created() {
    this.requesttab1(1);
  },
  methods: {
    goPager(val) {
      if (this.name == "name1") {
        this.requesttab1(val);
      }
      if (this.name == "name2") {
        this.requesttab2(val);
      }
    },
    requesttab1(page) {
      this.$api.OnlineMessage.getList(
        { page: page, size: this.pageSize, title: this.title  },
        {
          success: response => {
            if (response.data.code === 200) {
              if (!this._.isEmpty(response.data.data)) {
                this.currentPage = response.data.data.page || 1;

                this.dataSet = response.data.data;
              } else {
                this.$Message.warning({
                  content: this.$t("query.message.news_none"),
                  closable: true
                });
              }
            } else if (response.data.code === 404) {
              this.$Message.warning({
                content: this.$t("query.message.news_none"),
                closable: true
              });
            } else {
              this.$Message.warning({
                content: response.data.message,
                closable: true
              });
            }
          },
          error: errorMsg => {
            this.$Message.error({
              content: this.$t("common.tryAgain"),
              closable: true
            });
          }
        }
      );
    },
    handleSubmit() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.$api.OnlineMessage.add(this.formValidate, {
            success: response => {
              if (response.data.code === 200) {
                this.$Message.success("操作成功");
                this.$router.go(0);
              } else {
                this.$Message.warning({
                  content: response.data.message,
                  closable: true
                });
              }
              this.isShowLoader = false;
            },
            error: errorMsg => {
              this.isShowLoader = false;
              this.$Message.error({
                content: this.$t("common.tryAgain"),
                closable: true
              });
              this.$Loading.error();
            }
          });
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    requesttab2(page) {
      this.$api.OnlineMessage.myList(
        { page: page, size: this.pageSize, title: this.title },
        {
          success: response => {
            if (response.data.code === 200) {
              if (!this._.isEmpty(response.data.data)) {
                this.currentPage = response.data.data.page || 1;

                this.dataSet = response.data.data;
              } else {
                this.$Message.warning({
                  content: this.$t("query.message.news_none"),
                  closable: true
                });
              }
            } else if (response.data.code === 404) {
              this.$Message.warning({
                content: this.$t("query.message.news_none"),
                closable: true
              });
            } else {
              this.$Message.warning({
                content: response.data.message,
                closable: true
              });
            }
          },
          error: errorMsg => {
            this.$Message.error({
              content: this.$t("common.tryAgain"),
              closable: true
            });
            this.$Loading.error();
          }
        }
      );
    },
    tabclick(val) {
      this.currentPage = 1;
      this.title = ''
      if (val == "name1") {
        this.requesttab1(1);
      }
      if (val == "name2") {
        this.title = "";
        this.requesttab2(1);
      }
      if (val == "name3") {
        this.step = 1;
      }
    }
  }
};
</script>
<style scoped>
.pclass {
  margin: 5px 0;
  margin-bottom: 15px;
  color: #333;

  font-size: 16px;
  line-height: 30px;
}
>>>.ivu-input{
  font-size:16px
}
>>>.ivu-radio-wrapper{
  font-size:16px
}
.ivu-col {
  border: 1px solid #edeeee;
}
.ivu-form-item {
  margin-bottom: 10px;
  margin-top: 10px;
  padding-right: 20px;
  vertical-align: top;
}
.input {
  position: relative;
  width: 700px;
  height: 46px;
  border: 1px solid #9e9e9e;
  margin-bottom: 20px;
}
.new-content >>> .ivu-page {
  text-align: center;
  padding: 50px 0 15px;
}
.new-content >>> .ivu-page a {
  font-size: 16px;
}
>>> .ivu-input-group-prepend {
  padding: 4px 7px;
  font-size: 20px;
  width: 40px;
  font-weight: 400;
  font-weight: 200;
  line-height: 1;
  color: #495060;
  text-align: center;
  background-color: none;
  border-right: none !important;
}
.new-content >>> .ivu-page-total,
.new-content >>> .ivu-page-options-elevator,
.new-content >>> .ivu-page-options-elevator input {
  font-size: 15px;
  color: #777;
}
.new-content >>> .ivu-page-item-active {
  background-color: #0470e3;
  border-color: #0470e3;
}
.list li {
  position: relative;
  padding-right: 5px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-bottom: 0.5px solid #e9e9e9;
}
.list li.plaintext {
  padding-top: 0px;
  padding-bottom: 0px;
}
.list li:first-child {
  padding-top: 0;
}
 >>>.ivu-form-item-label{
  font-size:16px
}
.list li:first-child .cover {
  top: 0;
  display: block;
  transform: translateY(0);
}
.list li:last-child {
  padding-bottom: 10px;
  border-bottom: 0;
}
>>> .ivu-tabs-ink-bar {
  background-color: #ab0000 !important;
  height: 4px;
  width: 106px !important;
}
>>> .ivu-tabs-nav .ivu-tabs-tab-active {
  color: #ab0000 !important;
  font-weight: bold;
  font-size: 18px;
}
>>> .ivu-tabs-nav .ivu-tabs-tab {
  font-weight: 700;
  font-size: 18px;
  color: #9d9d9d;
  width: 106px;
  border-bottom: 5px solid #9d9d9d;
}
.list li .cover {
  width: 210px;
  position: absolute;
  top: 25px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.list li .cover:hover {
  text-decoration: none;
  box-shadow: none;
}
.list li .cover:after {
  width: 0;
  height: 0;
}
.list li .cover img {
  width: 100%;
  height: auto;
}
.list li .content {
  padding-top: 5px;
  cursor: pointer;
}
.list li.plaintext {
  padding-left: 0;
}
.list li.plaintext .content {
  min-height: 0;
  padding-top: 0;
}
.list li .content .title span:hover {
  color: #0470e3;
}
.list li .title {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.list li .title.hotes {
  position: relative;
  /*padding-left: 32px;*/
}
.list li .title .hot {
  border: 0.5px solid #2681ff;
  border-radius: 2px;
  color: #1f8afd;
  /*font-size: 8px;*/
  font-size: 10px;
  padding: 0 3px;
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 50%;*/
  /*transform: translateY(-50%);*/
  position: relative;
  top: -1px;
}
.list li .title.hotes a {
  padding-left: 5px;
}
.list li .title span {
  color: #333;
  font-size: 1.6rem;
  line-height: 24px;
}
/* .list li .title a:hover{
    color: #0470e3;
  } */
.list li .date {
  color: #999;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 0;
}
.list li .desc {
  font-size: 1.5rem;
  line-height: 24px;
  color: #666;
}
.nodata {
  text-align: center;
  padding-top: 30px;
  font-size: 16px;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineMessage/ListContent.vue